import React from "react";
import { TestTube2 } from "lucide-react";

/**
 * Bandeau permanent affiche au-dessus du header dashboard.
 *
 * Hauteur fixe a 36px (h-9). Le DashboardLayout positionne le header desktop
 * et mobile a top-9 + ajoute le padding necessaire au main content pour ne
 * pas chevaucher.
 *
 * Couleur ambree pour distinguer immediatement du look live (palette emerald).
 */
export default function SandboxBanner() {
  return (
    <div
      role="status"
      aria-live="polite"
      className="fixed top-0 left-0 right-0 z-[60] h-9 bg-amber-500 text-white shadow-md flex items-center"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-center gap-2 px-4 text-xs sm:text-sm font-medium">
        <TestTube2 className="h-4 w-4 shrink-0" aria-hidden="true" />
        <span className="truncate">
          Mode Test (Sandbox) — aucun mouvement d&apos;argent reel.{" "}
          <a
            href="/sandbox/scenarios"
            className="underline underline-offset-2 hover:text-amber-100"
            target="_blank"
            rel="noopener noreferrer"
          >
            Voir les scenarios de test
          </a>
        </span>
      </div>
    </div>
  );
}
